module.exports = __webpack_public_path__ + "static/img/hct3.570d250.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct3.jpg
// module id = wsiY
// module chunks = 0